<template>
    <div class="fondo-login">
      <v-container style="padding: 0;">
        <div style="display: flex;justify-content: center;align-items: center;height: 100vh;">
          <v-card class="login-card" style="padding: 1rem;">
            <v-card-title class="white--text" style="display: flex; justify-content: center;">
              <span class="headline" style="color: #636363; font-size: 1.8rem !important;">Bienvenido</span>
            </v-card-title>
            <v-card-text>
              <v-form @submit.prevent="login">
                <v-text-field v-model="username" label="Username" prepend-icon="mdi-account" required
                  class="white--text"></v-text-field>
                <v-text-field v-model="password" label="Password" type="password" prepend-icon="mdi-lock" required
                  class="white--text"></v-text-field>
                <v-btn type="submit" color="primary" block>Ingreso</v-btn>
              </v-form>
            </v-card-text>
          </v-card>
        </div>
      </v-container>
    </div>
  </template>
  <style>
  .fondo-login {
    width: 100%;
    background-color: #094698;
    background-image: url("../../../assets/login_geo.png");
    background-repeat: no-repeat;
    background-size: cover;
    height: 100vh;
    overflow: hidden;
  }
  
  .theme--light.v-icon {
    color: rgba(0, 0, 0, 0.54) !important;
  }
  
  .v-application .white--text {
    color: rgba(0, 0, 0, 0.6) !important;
    caret-color: rgba(0, 0, 0, 0.6) !important;
  }
  
  .theme--light.v-label {
    color: rgba(0, 0, 0, 0.6) !important;
  }
  
  .theme--light.v-text-field>.v-input__control>.v-input__slot:before {
    border-color: rgba(0, 0, 0, 0.42) !important;
  }
  
  .theme--light.v-input input,
  .theme--light.v-input textarea {
    color: rgba(0, 0, 0, 0.87) !important;
  }
  
  .fill-height {
    height: 100vh;
  }
  
  .login-card {
    background: white !important;
    color: rgb(0, 0, 0) !important;
  }
  
  .v-text-field__slot input {
    color: white !important;
  }
  
  .v-text-field__details {
    color: white !important;
  }
  
  .v-icon {
    color: white !important;
  }
  </style>
  <script>
  import Swal from "sweetalert2";
  export default {
    data() {
      return {
        username: '',
        password: ''
      };
    },
    methods: {
      login() {
        if (this.username == "neo" && this.password == "neo") {
          sessionStorage.setItem("usuario", this.username);
          this.$router.push("/task/tasklList");
        } else {
          Swal.fire({
            title: "¡Error!",
            text: "Los datos ingresados no son válidos",
            icon: "error",
            confirmButtonText: "Aceptar",
          });
          console.log('Username and Password are required');
        }
      }
    }
  };
  </script>